import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useTranslation } from 'react-i18next';

dayjs.extend(relativeTime);

const formatDate = (value) => {
  if (!value)
    return '—';

  const date = dayjs(value);
  return `${date.format('L LT')} (${date.fromNow()})`;
};

const SourceRow = ({ row }) => (
  <tr className="border-b border-gray-200 dark:border-gray-700 last:border-0">
    <td className="px-4 py-3 font-medium text-gray-900 dark:text-gray-100">{row.source}</td>
    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{formatDate(row.last_picture_at)}</td>
    <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{formatDate(row.last_aggregation_at)}</td>
  </tr>
);

const SkeletonRow = () => (
  <tr className="border-b border-gray-200 dark:border-gray-700 last:border-0">
    {Array.from({ length: 3 }).map((_, i) => (
      <td key={i} className="px-4 py-3">
        <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
      </td>
    ))}
  </tr>
);

export default function DataHealthSourcesTable({ rows, loading }) {
  const { t } = useTranslation();

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 dark:bg-gray-900 text-gray-600 dark:text-gray-300 uppercase text-xs">
            <tr>
              <th className="px-4 py-3 text-left">{t('Source')}</th>
              <th className="px-4 py-3 text-left">{t('Last picture taken')}</th>
              <th className="px-4 py-3 text-left">{t('Last aggregation')}</th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? Array.from({ length: 4 }).map((_, i) => <SkeletonRow key={i} />)
              : rows.length === 0
                ? (
                  <tr>
                    <td colSpan={3} className="px-4 py-6 text-center text-gray-500 dark:text-gray-400">
                      {t('No data available')}
                    </td>
                  </tr>
                )
                : rows.map(row => <SourceRow key={row.source} row={row} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
